// upload file type
export enum EnumFileType {
  video = 'video',
  image = 'image',
  pdf = 'pdf',
  word = 'word',
  zip = 'zip',
  other = 'other'
}

export const typeJudge = (type: string) => {
  if (type?.includes('image')) return EnumFileType.image;
  if (type?.includes('video')) return EnumFileType.video;
  if (type?.includes('pdf')) return EnumFileType.pdf;
  if (type?.includes('word')) return EnumFileType.word;
  if (type?.includes('zip')) return EnumFileType.zip;
  return EnumFileType.other;
};

// check whether all files in the fileList satisfy the mime(accept attribute)
export const validateMimeType = (fileList: FileList, accept: string) => {
  const unUploadFileList = Array.from(fileList);
  let n = 0;
  while (unUploadFileList.length > n) {
    if (unUploadFileList[n].type?.includes('video') && !accept.includes('video')) {
      return false;
    }
    if (unUploadFileList[n].type?.includes('audio') && !accept.includes('audio')) {
      return false;
    }
    if (unUploadFileList[n].type?.includes('image') && !accept.includes('image')) {
      return false;
    }
    if (unUploadFileList[n].type?.includes('application')) {
      // doc
      if (unUploadFileList[n].type?.includes('msword') && !accept.includes('word')) {
        return false;
      }
      if (unUploadFileList[n].type?.includes('wordprocessingml.document') && !accept.includes('word')) {
        return false;
      }
      // pdf
      if (unUploadFileList[n].type?.includes('pdf') && !accept.includes('pdf')) {
        return false;
      }
      // ppt / pptx
      if (unUploadFileList[n].type?.includes('powerpoint') && !accept.includes('powerpoint')) {
        return false;
      }
      if (unUploadFileList[n].type?.includes('presentation') && !accept.includes('powerpoint')) {
        return false;
      }
      // excel
      if (unUploadFileList[n].type?.includes('ms-excel') && !accept.includes('excel')) {
        return false;
      }
      if (unUploadFileList[n].type?.includes('spreadsheetml.sheet') && !accept.includes('excel')) {
        return false;
      }
      // zip
      if (unUploadFileList[n].type?.includes('zip') && !accept.includes('zip')) {
        return false;
      }
      if (unUploadFileList[n].type?.includes('x-rar-compressed') && !accept.includes('x-rar-compressed')) {
        return false;
      }
    }
    if (unUploadFileList[n].type?.includes('text')) {
      if (unUploadFileList[n].type?.includes('plain') && !accept.includes('txt')) {
        return false;
      }
      if (unUploadFileList[n].type?.includes('csv') && !accept.includes('csv')) {
        return false;
      }
      if (unUploadFileList[n].type?.includes('javascript') && !accept.includes('javascript')) {
        return false;
      }
      if (unUploadFileList[n].type?.includes('css') && !accept.includes('css')) {
        return false;
      }
    }
    n++;
  }
  return true;
};
